import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WhereToBuyComponent } from './where-to-buy.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [WhereToBuyComponent],
  imports: [CommonModule, RouterModule, I18nModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        WhereToBuy: {
          component: WhereToBuyComponent,
        },
      },
    }),
  ],
})
export class WhereToBuyModule {}
